import { fork } from 'redux-saga/effects';

export const makeRootSaga = sagas => function* rootSaga() {
  yield sagas.map(saga => fork(saga));
};

export const injectSagas = (store, { key, sagas }) => {
  const sagaStore = store;

  if (sagaStore.asyncSagas[key]) {
    return;
  }
  sagaStore.asyncSagas[key] = sagas;
  sagaStore.runSaga(makeRootSaga(sagas));
};

export default makeRootSaga;



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/store/sagas.js